/**
 * LOP — Collection badges sync for PLP Style ID swatch switches.
 */
(function () {
  'use strict';

  var PROMO_SELECTOR = '.product-item__media > .product-badge.lop-badge--promo';
  var DISCOUNT_SELECTOR = '.product-item__price .product-discount-percent-badge--inline.lop-badge--discount';
  var LABEL_SELECTOR = '[data-lop-collection-label]';

  function normalizeLabel(label) {
    if (!label || typeof label !== 'object') {
      return { text: null, color: null };
    }

    return {
      text: label.text || null,
      color: label.color || null,
    };
  }

  function applyLabelColor(el, color) {
    if (!el) return;

    if (color) {
      el.style.color = color;
    } else {
      el.removeAttribute('style');
    }
  }

  function syncLabel(card, label) {
    var state = normalizeLabel(label);
    var labelEl = card.querySelector(LABEL_SELECTOR);

    if (!state.text) {
      if (labelEl) labelEl.remove();
      return;
    }

    if (!labelEl) {
      labelEl = document.createElement('p');
      labelEl.className = 'product-item__collection-label';
      labelEl.setAttribute('data-lop-collection-label', '');

      var swatches = card.querySelector('.product-item__swatches-inline');
      var memorialLabel = card.querySelector('[data-memorial-day-sale-badge]');

      if (swatches && swatches.parentNode) {
        if (memorialLabel) {
          swatches.parentNode.insertBefore(labelEl, memorialLabel);
        } else {
          swatches.parentNode.insertBefore(labelEl, swatches.nextSibling);
        }
      } else {
        var priceRow = card.querySelector('.product-item__price-swatches-row');
        var priceEl = card.querySelector('.product-item__price');
        var anchor = memorialLabel || (priceRow ? priceRow.nextSibling : null) || (priceEl ? priceEl.nextSibling : null);

        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(labelEl, anchor);
        } else if (priceRow) {
          priceRow.parentNode.insertBefore(labelEl, priceRow.nextSibling);
        } else if (priceEl && priceEl.parentNode) {
          priceEl.parentNode.insertBefore(labelEl, priceEl.nextSibling);
        }
      }
    }

    labelEl.textContent = state.text;
    applyLabelColor(labelEl, state.color);
  }

  function extractLabelFromCard(card) {
    var labelEl = card.querySelector(LABEL_SELECTOR);
    if (!labelEl) {
      return { text: null, color: null };
    }

    var text = labelEl.textContent ? labelEl.textContent.trim() : null;
    var color = labelEl.style.color || null;

    return {
      text: text || null,
      color: color || null,
    };
  }

  function normalizeBadges(badges) {
    if (!badges || typeof badges !== 'object') {
      return {
        collectionPromoActive: false,
        discountOn: false,
        promo: null,
        promoColor: null,
        discountColor: null,
        discountPct: 0,
      };
    }

    return {
      collectionPromoActive: !!badges.collectionPromoActive,
      discountOn: !!badges.discountOn,
      promo: badges.promo || null,
      promoColor: badges.promoColor || null,
      discountColor: badges.discountColor || null,
      discountPct: parseInt(badges.discountPct, 10) || 0,
    };
  }

  function applyFilledColor(el, color) {
    if (!el) return;

    if (color) {
      el.classList.add('lop-badge--filled');
      el.style.backgroundColor = color;
      el.style.borderColor = color;
    } else {
      el.classList.remove('lop-badge--filled');
      el.removeAttribute('style');
    }
  }

  function syncPromoBadge(card, badges) {
    var media = card.querySelector('.product-item__media');
    if (!media) return;

    var promoEl = media.querySelector('.product-badge.lop-badge--promo');

    if (!badges.promo) {
      if (promoEl) promoEl.remove();
      return;
    }

    if (!promoEl) {
      promoEl = document.createElement('div');
      promoEl.className = 'product-badge lop-badge--promo';
      media.appendChild(promoEl);
    }

    promoEl.textContent = badges.promo;
    applyFilledColor(promoEl, badges.promoColor);
  }

  function syncDiscountBadge(card, badges) {
    var priceEl = card.querySelector('.product-item__price');
    if (!priceEl) return;

    var discountEl = priceEl.querySelector('.product-discount-percent-badge--inline.lop-badge--discount');
    var showDiscount =
      badges.discountOn && badges.discountPct > 0 && !!priceEl.querySelector('.sale');

    if (!showDiscount) {
      if (discountEl) discountEl.remove();
      return;
    }

    if (!discountEl) {
      discountEl = document.createElement('span');
      discountEl.className =
        'product-discount-percent-badge product-discount-percent-badge--inline lop-badge--discount';
      priceEl.appendChild(discountEl);
    }

    discountEl.textContent = badges.discountPct + '% OFF';
    applyFilledColor(discountEl, badges.discountColor);
  }

  function extractBadgesFromCard(card) {
    var promoEl = card.querySelector(PROMO_SELECTOR);
    var discountEl = card.querySelector(DISCOUNT_SELECTOR);
    var promoColor = null;
    var discountColor = null;

    if (promoEl && promoEl.style.backgroundColor) {
      promoColor = promoEl.style.backgroundColor;
    }
    if (discountEl && discountEl.style.backgroundColor) {
      discountColor = discountEl.style.backgroundColor;
    }

    var discountPct = 0;
    if (discountEl && discountEl.textContent) {
      var match = discountEl.textContent.match(/(\d+)\s*%/);
      if (match) discountPct = parseInt(match[1], 10) || 0;
    }

    return {
      collectionPromoActive: !!(promoEl || (discountEl && discountPct > 0)),
      discountOn: !!discountEl,
      promo: promoEl ? promoEl.textContent.trim() : null,
      promoColor: promoColor,
      discountColor: discountColor,
      discountPct: discountPct,
    };
  }

  function syncProductItem(card, badges, label) {
    if (!card) return;

    var state = normalizeBadges(badges);
    syncPromoBadge(card, state);
    syncDiscountBadge(card, state);
    syncLabel(card, label);
  }

  window.LOPCollectionBadges = {
    syncProductItem: syncProductItem,
    extractBadgesFromCard: extractBadgesFromCard,
    normalizeBadges: normalizeBadges,
    syncLabel: syncLabel,
    extractLabelFromCard: extractLabelFromCard,
    normalizeLabel: normalizeLabel,
  };
})();
